import { Provider } from "@angular/core";

import { ProcesoDatos } from "./ProcesoDatos";
import { ProcesoDatosImp } from "./ProcesoDatosImp";

export const procesoDatosProviders: Provider[] = [
    { provide: ProcesoDatos, useClass: ProcesoDatosImp }
];
